import { useState } from 'react';
import { FAIRY_THEMES } from '../../constants/fairyThemes';
import { useAuth } from '../../context/AuthContext';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const FAIRIES = [
  {
    id: 'aurora',
    name: 'Aurora',
    title: 'La Guardiana del Alba',
    tagline: 'Silenciosa y precisa. Conoce tus gustos mejor que vos mismo.',
    genres: 'Psychological · Thriller · Seinen',
  },
  {
    id: 'ember',
    name: 'Ember',
    title: 'La Chispa Errante',
    tagline: 'Inquieta y apasionada. Siempre encuentra algo que te va a prender fuego.',
    genres: 'Spokon · Shounen · Acción',
  },
  {
    id: 'sage',
    name: 'Sage',
    title: 'La Susurrante del Bosque',
    tagline: 'Antigua y paciente. Te guía hacia los títulos que otros pasan por alto.',
    genres: 'Slice of Life · Iyashikei · Histórico',
  },
  {
    id: 'luna',
    name: 'Luna',
    title: 'La Dama de la Medianoche',
    tagline: 'Refinada y melancólica. Sabe cuándo necesitás algo que te llegue al alma.',
    genres: 'Romance · Drama · Josei',
  },
  {
    id: 'nova',
    name: 'Nova',
    title: 'La Estrella Fugaz',
    tagline: 'Caótica y alegre. Sus recomendaciones no tienen lógica... pero siempre aciertan.',
    genres: 'Comedia · Ecchi · Isekai ligero',
  },
];

export default function FairySelector({ onSelect }) {
  const { fairyId, setFairyId } = useAuth();
  const [selected, setSelected] = useState(fairyId);
  const [saving,   setSaving]   = useState(false);
  const [saved,    setSaved]    = useState(false);

  const handleSelect = async (id) => {
    if (id === selected || saving) return;
    setSelected(id);
    setSaving(true);
    setSaved(false);

    try {
      await fetch(`${API_URL}/user/fairy`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({ fairyId: id }),
      });
      setSaved(true);
      setFairyId(id);
      onSelect?.(id);
      setTimeout(() => setSaved(false), 2000);
    } catch (err) {
      console.error('Error guardando hada:', err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fairy-selector">
      <div className="fairy-selector-header">
        <h2 className="fairy-selector-title">Tu Hada Guía</h2>
        <p className="fairy-selector-sub">
          Ella te recomendará animes y te avisará de novedades a su manera.
        </p>
        {saved && <span className="fairy-selector-saved">✓ Hada guardada</span>}
      </div>

      <div className="fairy-cards-grid">
        {FAIRIES.map((fairy) => {
          const theme    = FAIRY_THEMES[fairy.id];
          const isActive = selected === fairy.id;

          return (
            <div
              key={fairy.id}
              className={`fairy-card${isActive ? ' fairy-card--active' : ''}`}
              style={{
                '--fairy-primary':   theme.primary,
                '--fairy-secondary': theme.secondary,
                '--fairy-glow':      theme.glow,
              }}
              onClick={() => handleSelect(fairy.id)}
            >
              <div className="fairy-card-img-wrapper">
                <img
                  src={`/fairies/${fairy.id}.png`}
                  alt={fairy.name}
                  className="fairy-card-img"
                />
                {isActive && <div className="fairy-card-active-ring" />}
              </div>

              <div className="fairy-card-info">
                <span className="fairy-card-name">{fairy.name}</span>
                <span className="fairy-card-title-text">{fairy.title}</span>
                <span className="fairy-card-tagline">{fairy.tagline}</span>
                <span className="fairy-card-genres">{fairy.genres}</span>
              </div>

              {isActive && (
                <div className="fairy-card-badge">Tu hada actual</div>
              )}
            </div>
          );
        })}
      </div>

      <p className="fairy-selector-disclaimer">
        Ashveil recomienda usar el sistema de estados —{' '}
        <span className="fairy-disclaimer-highlight">
          Viendo, Completado, En pausa, Dropeado, Pendiente
        </span>{' '}
        — para que tu Hada te conozca mejor. Aunque Ashveil no promete
        que sus hadas no insistan en sus gustos particulares.
      </p>
    </div>
  );
}
